import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './styles.module.scss';

import SearchInput from 'OK/components/input/search';
import CardLayout from 'OK/components/layouts/card';
import ContentLayout from 'OK/components/layouts/content';
import TextLayout from 'OK/components/layouts/content/text';
import Link from 'OK/components/link';
import Menu from 'OK/components/menu';
import PageMenu from 'OK/components/menus/page';
import PageTitle from 'OK/components/pageTitle';
import { search } from 'OK/state/app/actions';
import useI18n from 'OK/util/hooks/useI18n';
import { I18n } from 'OK/util/i18n';
import { r } from 'OK/util/routing';

export default function FourOhFour() {
  const dispatch = useDispatch();
  const router = useRouter();
  const useDesktopLayout = useSelector((state) => state.app.useDesktopLayout);
  const [searchQuery, setSearchQuery] = useState('');
  const { t } = useI18n();

  const submitSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();

    dispatch(search(searchQuery));
    router.push(`/search?q=${encodeURIComponent(searchQuery)}`);
  };
  return (
    <>
      <PageTitle>{t('PAGE_TITLE_404')}</PageTitle>
      <Menu>
        <PageMenu showBackButton />
      </Menu>
      <ContentLayout
        backgroundImage='/img/404.jpg'
        backgroundImage2x='/img/404@2x.jpg'
        backgroundPosition={useDesktopLayout ? 'center 75%' : 'center'}
        className={styles.container}
      >
        <TextLayout>
          <h2 className={styles.header}>{t('404_PAGE_OOPS')}</h2>
        </TextLayout>
        <CardLayout className={styles.card} contextOverride='base' fixedWidth={false}>
          <h3>{t('404_PAGE_HEADER')}</h3>
          <p>
            <I18n i18nKey='404_PAGE_MESSAGE'>
              The page doesn&apos;t exist, or it may have moved. You can{' '}
              <Link className={styles.inlineLink} href='/solutions/contact'>
                report this
              </Link>
              .
            </I18n>
          </p>
          <form onSubmit={(e) => submitSearch(e)}>
            <SearchInput placeholder={t('SEARCH_PLACEHOLDER')} onChange={(e) => setSearchQuery(e.target.value)} />
          </form>
          <Link block className={styles.homeLink} href={r('/')} withCaret>
            {t('GO_TO_HOME')}
          </Link>
        </CardLayout>
      </ContentLayout>
    </>
  );
}

FourOhFour.layoutProps = { contentTopPadding: 'menuOnly', padFooter: false };

export async function getStaticProps({ locale }) {
  const i18nProps = await serverSideTranslations(locale, ['common']);
  return {
    props: {
      ...i18nProps,
    },
  };
}
